import { render, staticRenderFns } from "./UploadCover.vue?vue&type=template&id=7d1a42af&"
import script from "./UploadCover.vue?vue&type=script&lang=js&"
export * from "./UploadCover.vue?vue&type=script&lang=js&"
import style0 from "./UploadCover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports